module.exports = __webpack_public_path__ + "img/aboutus.cd68b341.svg";